const comment = (merchant) => {
  return merchant
    ? '// loadStripe is initialized with your real test publishable API key.'
    : '// loadStripe is initialized with a fake API key.\n// Sign in to see examples pre-filled with your key.';
};

export default ({keys, merchant}) => `{+add-react-modules}
import React from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
{/add-react-modules}
import CheckoutForm from "./CheckoutForm";
import "./App.css";

{+load-stripe}
// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
${comment(merchant)}
const promise = loadStripe("${keys.publishable}");
{/load-stripe}

export default function App() {
  return (
    <div className="App">
      {+init-elements}
      <Elements stripe={promise}>
        <CheckoutForm />
      </Elements>
      {/init-elements}
    </div>
  );
}
`;
